import React from 'react';
import { DynamicFormBuilder } from './SchemaFormBuilder';

export interface CollectionFormBuilderProps {
  schema: Record<string, any>;
  initialData?: Record<string, any>;
  onSubmit: (data: Record<string, any>) => void;
  loading?: boolean;
  hideSubmitButton?: boolean;
}

/**
 * Thin wrapper around DynamicFormBuilder for collection item forms.
 * Schema format: flat object  { "Field Name": { title, "x-control": {...} }, ... }
 * Rendering (tabs, controls) is identical to the Configuration Management page.
 */
export const CollectionFormBuilder = React.forwardRef<HTMLFormElement, CollectionFormBuilderProps>(({
  schema,
  initialData = {},
  onSubmit,
  loading = false,
  hideSubmitButton = false,
}, ref) => {
  return (
    <DynamicFormBuilder
      schema={schema}
      initialData={initialData}
      onSubmit={onSubmit}
      loading={loading}
      hideSubmitButton={hideSubmitButton}
      formRef={ref as React.RefObject<HTMLFormElement | null>}
    />
  );
});

CollectionFormBuilder.displayName = 'CollectionFormBuilder';
